/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Coord_LngInputs */

const vi_grower_coord_lng = /** @type {(inputs: Grower_Coord_LngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinh độ`)
};

/**

* @param {Grower_Coord_LngInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_coord_lng = /** @type {((inputs?: Grower_Coord_LngInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Coord_LngInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_coord_lng(inputs)
});